import { useState, useRef, useEffect } from "react";
import { aiChatBotMaui } from "../services/apiService";
import { v4 as uuidv4 } from 'uuid';
import VoiceRecorder2, { VoiceRecorderHandle } from "../components/VoiceRecorder2";
import send from "../assects/img/Send.png" 
import play_icon from "../assects/img/play_icon.png" 
import gray_send from "../assects/img/Gray_Send.png" 
import "../custom.css";
import YouTube from 'react-youtube';
import xorologo from "../assects/img/xoro-Logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from '@fortawesome/free-solid-svg-icons';

interface Message {
  sender: "user" | "bot" | "loading";
  text: string;
}

function MauiV2() {
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [wholeLoading, setWholeLoading] = useState(false);
  const chatEndRef = useRef<HTMLDivElement>(null);
  const [current_user_chat_code, setCurrent_user_chat_code] = useState("");
  const [videoMuted, setVideoMuted] = useState(true);
  const [popupVisible, setPopupVisible] = useState(false);

  const voiceRecorderRef = useRef<VoiceRecorderHandle>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const CC = uuidv4() 
    setCurrent_user_chat_code(CC);
    const init = async () => {
        setWholeLoading(true);
        await handleBotReply("SUBS123",CC);
        setWholeLoading(false);
    };

    init();
  }, []);

  const handleBotReply = async (userInput: string, cc?: any, audioBlob?: Blob) => {
    try {
      setLoading(true);

      const formData = new FormData();
      let audio = false;

      voiceRecorderRef.current?.stopRecording();

      if (audioBlob) {
        formData.append('audio', audioBlob, 'voice.webm');
        formData.append('userQuery', "");
        setMessages(prev => [...prev, { sender: "user", text: "🎤 (voice message sent)" }]);
        setMessages(prev => [...prev, { sender: "loading", text: "🤖 Getting response..." }]);
        audio = true;
      } else {
        formData.append('userQuery', userInput);
        if(userInput !== "SUBS123"){
            const userMessage: Message = { sender: "user", text: input };
            setMessages((prev) => [...prev, userMessage]);
        }
        
        setMessages((prev) => [...prev, { sender: "loading", text: "🤖 Getting response..." }]);
      }

      formData.append('current_user_chat_code', current_user_chat_code || cc);

      const response = await aiChatBotMaui(formData);
      const userAudioText = response.transcribed_text;
      const botReply = response.reply || "No response";

      if (audio) {
        setMessages((prev: any) => {
          const updated = prev.map((msg: any, index: number) => {
            if (index === prev.length - 2) {
              return { ...msg, text: `🎤 (voice message sent) - ${userAudioText}` };
            } else {
              return msg;
            }
          });
          return [...updated];
        });
      }

      setMessages((prev) => {
        const filtered = prev.filter(msg => msg.text !== "🤖 Getting response...");
        return [...filtered, { sender: "bot", text: botReply }];
      });

      if (response.role !== "") {
        localStorage.setItem('userBotRole', response.role);
      }
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Sorry, something went wrong." },
      ]);
      setMessages((prev) => {
        const filtered = prev.filter(msg => msg.text !== "🤖 Getting response...");
        return [...filtered];
      });
    } finally {
      setLoading(false);
    }
  };

  const sendMessage = async (audioBlob?: Blob) => {
    const currentInput = input;
    setInput("");
    await handleBotReply(currentInput, "" , audioBlob);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") sendMessage();
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleVideoEnd = () => {
    console.log("Video finished!");
    // 🔁 Call your custom function here
  };

  const videoOptions = {
    height: '',
    width: '100%',
    playerVars: {
      autoplay: 1, 
      controls: 1, 
      modestbranding: 1,
      rel: 0,       
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setVideoMuted(!videoMuted)
    }
  };

  return (
    <div className="w-full h-screen flex flex-col items-center justify-between lg:bg-gray-100 font-sans">
        {!wholeLoading &&<div className="w-[95%] lg:w-full h-[50px] pt-3 fixed m-auto top-0 left-1/2 left-1/2 transform -translate-x-1/2 lg:relative z-50 bg-white text-left lg:px-6 lg:py-3 text-lg font-semibold flex items-center justify-between lg:my-3">
            {/* <span className="text-gray-800 me-2 font-extrabold">Maui  </span> */}
            {/* <span className="bg-clip-text text-transparent font-extrabold bg-gradient-to-r from-[#f06292] to-[#ba68c8] font-bold">Assistant</span> */}
            <div className="bg-blue-600 rounded-full p-1 px-1 h-full flex items-center justify-center h-full cusor-pointer" onClick={()=>setPopupVisible(!popupVisible)}>
                <img src={play_icon} alt="xoro logo" className="h-full w-auto" onClick={()=>setPopupVisible(!popupVisible)}/>
            </div>
            <div className="w-[30%] h-full flex items-center justify-end">
                <img src={xorologo} alt="xoro logo" className="h-full w-auto" />
            </div>
        </div>}

        <div className="flex-1 w-[95%] lg:w-full flex justify-between mb-2">
            <div className="w-[28%] sha1 rounded hidden lg:block">
                {/* <YouTube
                    videoId="dQw4w9WgXcQ" 
                    opts={videoOptions}
                    onEnd={handleVideoEnd}
                /> */}
                <div className="relative">
                    <video
                        ref={videoRef}
                        src="https://duk4k3bg3d0pj.cloudfront.net/XSP+F25.mp4"
                        playsInline
                        autoPlay
                        muted
                        className="w-full"
                    />
                    <div className="absolute w-[20px] top-2 right-2 rounded cursor-pointer">
                        {
                            videoMuted ? 
                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTy99u5cJOX4PWA1fD9XuqK35R-_yEK34qkPA&s" alt="Mute Icon" className="w-full h-full" onClick={toggleMute} />
                            : <img src="https://png.pngtree.com/element_our/20190528/ourmid/pngtree-mute-icon-image_1127853.jpg" alt="unmute Icon" onClick={toggleMute} className="w-full h-full" />
                        }
                    </div>
                </div>
            </div>
            <div className="lg:w-[70%] w-full relative rounded lg:sha1 lg:h-full mt-14 lg:mt-0">
                <div className="w-full lg:px-20 lg:py-4 overflow-y-auto space-y-4 lg:h-[85%] mb-14">
                    {messages.map((msg, index) => (
                        <div
                        key={index}
                        className={`px-5 py-4 rounded-xl text-sm lg:leading-relaxed aaa ${
                            msg.sender === "user"
                            ? "bg-[#5D67F2] text-white w-fit max-w-[90%] self-end ml-auto"
                            : msg.sender === "loading"
                            ? "bg-white text-gray-600 w-fit max-w-[90%] self-start mr-auto"
                            : "bg-white text-gray-800 w-fit max-w-[90%] self-start mr-auto"
                        }`}
                        dangerouslySetInnerHTML={{
                            __html:
                            msg.text === "🤖 Getting response..."
                                ? `<div class="flex items-center space-x-2">
                                    <span class="text-sm">Getting Response</span>
                                    <div class="flex space-x-1">
                                    <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0s;"></div>
                                    <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0.1s;"></div>
                                    <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0.2s;"></div>
                                    </div>
                                </div>`
                                : msg.text,
                        }}
                        />
                    ))}
                    <div ref={chatEndRef} />
                </div>

                <div className="w-[95%] bg-white lg:w-[50%] m-auto lg:px-6 flex items-center h-[60px] lg:h-[60px] fixed lg:absolute lg:bottom-5 bottom-0 pb-5 left-1/2 transform -translate-x-1/2 ">
                    <div className="flex items-center justify-between bg-white rounded-full shadow-md lg:px-4 px-2 pe-1 lg:py-2 py-0.5 w-[90%] h-full">
                        <input
                            type="text"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="What’s in your mind?…"
                            className="flex-1 px-2 py-1 text-sm bg-transparent focus:outline-none w-[95%] h-full"
                        />
                        <button onClick={() => sendMessage()} disabled={loading} className="h-full lg:py-1 w-auto pe-1">
                            {loading ? <img src={gray_send} alt="send" className="w-auto h-full"/> : <img src={send} alt="send" className="h-full"/>}
                        </button>
                    </div>
                    <div className="h-full">
                        <VoiceRecorder2
                            ref={voiceRecorderRef}
                            onAudioRecorded={(audioBlob: Blob) => sendMessage(audioBlob)}
                            disabled={loading}
                        />
                    </div>
                </div>
            </div>
        </div>
        {
            wholeLoading && <div style={{position:'fixed',top:'0',bottom:'0',width:'100%',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
                                <div style={{background:'white',border:' 2px solid #0050C8'}} className="flex items-center rounded px-7 py-3">
                                    <div className="spinner me-2"></div>
                                    <p className="text-blue-700">Preparing your chat please wait...</p> 
                                </div>
                            </div>
        }
        {
            popupVisible && <div style={{position:'fixed',top:'55px',width:'95%',display:'flex',justifyContent:'center'}} className="sha1 bg-white rounded p-2">
                                <div style={{background:'white',border:' 2px solid #0050C8'}} className="flex items-center rounded px-7 py-3">
                                    <div className="spinner me-2"></div>
                                    <p className="text-blue-700">Preparing your chat please wait...</p> 
                                </div>
                            </div>
        }
    </div>
  );

}

export default MauiV2;
